// noinspection DuplicatedCode
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { Colors } from "../../../assets/Colors";
import { DynamicTablev3 } from "../../../components/tablecard/DynamicTable";
import { Card, CardBody } from "@material-tailwind/react";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import { useForm } from "../../../components/isRequired";
import { useMutation } from "@tanstack/react-query";
import { fetchGet } from "../../../fetchers";
import { toast } from "react-toastify";
import { maxPageGlobal } from "../../../assets/config";
import { GetBody, GetTh } from "../../../components/tablecard/TableEtc";

const ReportPurchaseRequisiton = ({}) => {
  let initialState = {
    Bulan: new Date(),
    BisnisUnitID: "U0002",
  };

  const validations = [];

  const { values, errors, touched, customHandler } = useForm(
    initialState,
    validations
  );

  const [data, setData] = useState(null);
  const [dataUpkeep, setDataUpkeep] = useState(null);
  const mutationData = useMutation((param) =>
    fetchGet(
      "Procurement/Report/PurchaseRequisition/" +
        param.BisnisUnitID +
        "/" +
        param.Bulan +
        "/" +
        param.Tahun +
        "/" +
        param.Bagian +
        "/" +
        param.search
    )
  );
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [detail, setDetail] = useState({});
  const [count, setCount] = useState(maxPageGlobal);
  const [start, setStart] = useState(0);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [param, setParam] = useState({
    start: start,
    count: count,
    search: "MSR",
    BisnisUnitID: "U0002",
    Bagian: "B",
    Bulan: (new Date(values.Bulan).getMonth() + 1).toString(),
    Tahun: new Date(values.Bulan).getFullYear().toString(),
  });
  useEffect(() => {
    toast.info("Loading table!", {
      position: "top-center",
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      theme: "light",
    });

    mutationData.mutate(param, {
      onSuccess: async (data, context) => {
        let calc = data?.count - 1;
        if (calc === 0) {
          calc = 1;
        }

        if (calc % count === 0) {
          calc = calc + 1;
        }

        let tempMaxPage = data.data ? Math.ceil(calc / count) : 1;
        setMaxPage(tempMaxPage);
      },
    });
  }, [param]);

  const header = [
    { name: "No. MSR", key: "PurchaseRequisitionID" },
    { name: "Tanggal MSR ", key: "DatePR", modifiers: "Date" },
    { name: "Keterangan", key: "Remarks", modifiers: "Text" },
    { name: "Bagian", key: "NamaBagian", modifiers: "Text" },
    { name: "Pembuat ", key: "NamaKaryawan", modifiers: "Text" },
    { name: "Pemohon", key: "Requester", modifiers: "Text" },
    { name: "Tipe", key: "Tipe", modifiers: "Text" },
    { name: "Status", key: "STATUS", modifiers: "Text" },
    { name: "Action", key: "LihatPR", modifiers: "LihatPR" },
  ];

  const filterData = (event) => {
    setSearch(event.target.value);
  };
  const filterApi = () => {
    let bagian = "B";
    if (values.Bagian) bagian = values.Bagian;
    setParam({
      start: start,
      count: count,
      search: search,
      BisnisUnitID: values.BisnisUnitID,
      Bulan: (new Date(values.Bulan).getMonth() + 1).toString(),
      Tahun: new Date(values.Bulan).getFullYear().toString(),
      Bagian: bagian,
    });
  };
  let user = JSON.parse(localStorage.getItem("user"));

  const getDataGeneralFromURL = () =>
    new Promise((resolve, reject) => {
      setTimeout(() => {
        fetch(
          process.env.REACT_APP_API_URL +
            "Procurement/Cetak/PurchaseRequisition/" +
            param.BisnisUnitID +
            "/" +
            param.Bulan +
            "/" +
            param.Tahun +
            "/" +
            param.Bagian +
            "/" +
            param.search,
          {
            method: "GET", // or 'PUT'
            headers: {
              "Content-Type": "xlsx",
              Accept: "*/*",
              Authorization: "Bearer " + user.Token,
            },
          }
        )
          .then((response) => response.blob())

          .then((data) => {
            var csvURL = window.URL.createObjectURL(data);
            var tempLink = document.createElement("a");
            tempLink.href = csvURL;
            tempLink.setAttribute("download", "MSR-Laporan.xlsx");
            tempLink.click();
          });
      });
    }, 2000);

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>
        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <Card>
                <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                  <div className={"w-1/4"}>
                    <HrdInputGenerator
                      type={"BisnisUnit"}
                      name={"BisnisUnitID"}
                      title={"BisnisUnit"}
                      value={values}
                      required={true}
                      onChange={customHandler}
                      touched={touched}
                      errors={errors}
                      size={"full"}
                    />
                  </div>
                  <div className={"w-1/4"}>
                    <HrdInputGenerator
                      type={"bulan"}
                      name={"Bulan"}
                      title={"Bulan"}
                      value={values}
                      required={true}
                      onChange={customHandler}
                      touched={touched}
                      errors={errors}
                      size={"full"}
                    />
                  </div>
                  <div className={"w-1/4"}>
                    <HrdInputGenerator
                      type={"Bagian"}
                      name={"Bagian"}
                      title={"Bagian"}
                      value={values}
                      required={true}
                      onChange={customHandler}
                      touched={touched}
                      errors={errors}
                      size={"full"}
                    />
                  </div>
                  <div className={"w-1/4"}>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Buka data
                    </label>

                    <button
                      type="button"
                      onClick={filterApi}
                      className=" text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-2 px-7 py-2 text-center mr-2 mb-2 "
                    >
                      Buka
                    </button>
                  </div>
                  <div className={"w-1/4 ml-3 "}>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mt-5">
                      Download Excel
                    </label>
                    <div className="inline-block relative w-full  ">
                      <button
                        onClick={() => getDataGeneralFromURL()}
                        className="appearance-none block text-center w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
                      >
                        Print
                      </button>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col items-center content-center ">
                  <CardBody className="w-full pt-0 mt-10">
                    <div className="overflow-x-auto overscroll-y-auto max-h-96">
                      <table className="table-auto  bg-transparent border-collapse ">
                        <thead>
                          <tr>
                            {GetTh("Nomor MSR", 1)}
                            {GetTh("Tanggal", 8)}
                          </tr>
                          <tr>
                            {GetTh("Tipe", 1)}
                            {GetTh("Keterangan", 1)}
                            {GetTh("Bagian", 1)}
                            {GetTh("Pemohon", 1)}
                            {GetTh("Kode Barang", 1)}
                            {GetTh("Nama Barang", 1)}
                            {GetTh("Qty", 1)}
                            {GetTh("Satuan", 1)}
                            {GetTh("Spesifikasi", 1)}
                          </tr>
                        </thead>
                        <tbody>
                          {mutationData.data &&
                            mutationData.data.data &&
                            mutationData.data.data.map((data, id) => {
                              return (
                                <>
                                  <tr
                                    key={id + "-headder"}
                                    className="bg-gray-100"
                                  >
                                    {GetBody(
                                      data.PurchaseRequisitionID,
                                      false,
                                      1
                                    )}
                                    {GetBody(
                                      new Date(data.Tanggal).toDateString(),
                                      false,
                                      8
                                    )}
                                  </tr>
                                  {data.Detail &&
                                    data.Detail.map((detail, secondidd) => {
                                      return (
                                        <>
                                          <tr
                                            key={
                                              id + "-" + secondidd + "detail"
                                            }
                                          >
                                            {GetBody(data.Tipe, false, 1)}
                                            {GetBody(data.Remarks, false, 1)}
                                            {GetBody(data.NamaBagian, false, 1)}
                                            {GetBody(
                                              data.NamaKaryawan,
                                              false,
                                              1
                                            )}
                                            {GetBody(
                                              detail.KodeBarang,
                                              false,
                                              1
                                            )}
                                            {GetBody(
                                              detail.NamaBarang,
                                              false,
                                              1
                                            )}
                                            {GetBody(detail.Qty, false, 1)}
                                            {GetBody(detail.Qty, false, 1)}
                                            {GetBody(
                                              detail.Specification,
                                              false,
                                              1
                                            )}
                                          </tr>
                                        </>
                                      );
                                    })}
                                </>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportPurchaseRequisiton;
